const isLocalDevelopment = window.location.hostname === 'localhost';

const Config = {
    apiUrl: process.env.REACT_APP_ENV_API_URL,
    isLocalDev: isLocalDevelopment,
    frontendUrl: window.location.origin,
    maintenanceMode: process.env.REACT_APP_MAINTENANCE_MODE === 'true'
};

export default Config;